// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3r_ZC","question":"Question_question__MxevI","description":"Question_description__2ygX9"};